module.exports = __webpack_public_path__ + "img/attack_iceberg.cb8f023a.png";